import styled from 'styled-components/macro';
import { Timeline, TabBar } from '~/components';
import ClubStats from './components/clubStats';
import Tabs from './components/Tabs';

export const Container = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  display: grid;
  grid-template-columns: ${({ tabletMode }) =>
    tabletMode ? `auto auto 200px` : `1fr 200px 1fr`};
  grid-template-rows: ${({ tabletMode }) => (tabletMode ? `auto 1fr` : `1fr`)};
  grid-template-areas: ${({ tabletMode, tab }) =>
    tabletMode
      ? `"header header minute"
    "${tab} ${tab} minute"`
      : `"local minute away"`};
  flex-grow: 1;
`;
export const ContainerSm = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const ContainerTabBar = styled(TabBar)`
  z-index: 5;
  position: sticky;
  top: 0px;
  background-color: ${({ theme }) => theme.dark};
`;

export const MinuteByMinuteBlock = styled(Timeline)`
  width: 200px;
  max-width: 200px;
  min-width: 200px;
  grid-area: minute;
`;

export const MinuteByMinuteBlockSm = styled(Timeline)`
  width: 100%;
  height: 100%;
`;

export const LocalBlock = styled.div`
  background-color: ${({ theme }) => theme.white};
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column-reverse;
  grid-area: local;
  flex-grow: 1;
  & table {
    width: 100%;
  }
`;

export const VisitantBlock = styled.div`
  background-color: ${({ theme }) => theme.dark4};
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column-reverse;
  grid-area: away;
  flex-grow: 1;
  & table {
    width: 100%;
  }
`;

export const ClubStatsMobile = styled(ClubStats)`
  position: sticky;
  bottom: 0;
`;

export const TabsSections = styled(Tabs)`
  position: sticky;
  top: 0;
  grid-area: header;
  z-index: 3;
  height: 42px;
  border-top: solid 1px ${({ theme }) => theme.gray3};
`;
